<template>
	<section class="Carousel">
		<div class="cards">
			<A v-for="(card, i) in myMeta" :key="`card_${i}`" class="card" @click="onClickCard(card)">
				<img :src="card.image" :data-size="image_size" />
				<div class="contents">
					<h2>{{ card.title }}</h2>
					<p>{{ card.desc }}</p>
				</div>
				<div class="buttons">
					<Button v-for="btn in getButtons(i)" :key="`btn_${btn.id}`" @click.prevent.stop="onClickButton(btn)">{{btn.label}}</Button>
				</div>
			</A>
		</div>
	</section>
</template>

<script>
	export default {
		props: ['meta', 'items', 'image_size'],

		computed: {
			myMeta() {
				return typeof this.meta === 'string' ? this.parseJSON(this.meta) : this.meta;
			}
		},
		
		methods: {
			getButtons(i) {
				return this.items ? this.items.filter(e => e.target_seq == i) : [];
			},

			onClickButton(btn) {
				this.$emit('select', 'button', btn);
			},

			onClickCard(card) {
				this.$emit('select', 'card', card);
			}
		}
	};
</script>

<style scoped lang="scss">
	.Carousel {
		// max-width: 80vw;
		overflow-x: auto;
		padding: 0.5rem;

		.cards {
			display: flex;
			flex-direction: row;

			.card {
				flex: 0 0 27rem;
				position: relative;
				border-radius: 1rem;
				overflow: hidden;
				background-color: white;
				box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
				display: flex;
				flex-direction: column;
				transition: all .3s;
				max-width: 85%;

				&:hover {
					transform: translateY(-0.5rem);
					filter: brightness(1.1);
				}

				&:not(:first-child) {
					margin-left: 1rem;
				}

				&:last-child {
					margin-right: 1rem;
				}

				img {
					
					max-width: 100%;
					flex: 0 0 14rem;
					height: 14rem;
					object-fit: cover;
					object-position: center;

					&[data-size='contain'] {
						flex: initial;
						height: initial;
					}
					
				}

				.contents {
					padding: 1rem;
					flex: 1;
					
					&>* {
						&:not(:first-child) {
							margin-top: 1rem;
						}
					}

					h2 {
						color: #222;
						font-size: 1.6rem;
					}

					p {
						color: #444;
						font-size: 1.4rem;
						white-space: pre-wrap;
					}
				}

				.buttons {
					padding: 1rem;
					position: relative;
					padding-top: 0;

					.Button {
						width: 100%;

						&:not(:first-child) {
							margin-top: 1rem;
						}
					}
				}
			}
		}
	}
</style>
